import { Link } from "@tanstack/react-router";

import { useReservoirs } from "@/lib/api/reservoirs";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/error-state";

export function ReservoirsListPage() {
  const q = useReservoirs();
  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">Reservoirs</h1>
        <Link to="/reservoirs/new">
          <Button>New reservoir</Button>
        </Link>
      </header>
      {q.error && <ErrorState error={q.error} retry={q.refetch} />}
      {q.isLoading && (
        <p className="text-sm text-muted-foreground">Loading…</p>
      )}
      <ul className="divide-y rounded-md border">
        {q.data?.items.map((r) => (
          <li key={r.id}>
            <Link
              to="/reservoirs/$reservoirId"
              params={{ reservoirId: r.id }}
              className="block px-4 py-3 hover:bg-accent/50"
            >
              <div className="flex items-baseline justify-between gap-4">
                <div>
                  <p className="font-medium">{r.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {r.container_type}
                    {r.system_provided && " · system"}
                    {r.archived_at && " · archived"}
                  </p>
                </div>
                <p className="text-xs text-muted-foreground tabular-nums">
                  {r.gal_per_inch !== undefined &&
                    `${r.gal_per_inch} gal/in`}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
